.imageGallery {
  :global(.fancybox__button--fullscreen) {
    display: none;
  }

  :global(.fancybox__button--slideshow) {
    display: none;
  }

  :global(.fancybox__button--thumbs) {
    display: none;
  }
}

.bookmarkIconButton {
  filter: drop-shadow(0px 5px 5px rgb(0 0 0 / 60%));
  stroke-width: 20px;
  stroke: black;
  stroke-linejoin: round;
  // stroke: ${(props) => (props.isBookmarked ? 'white' : '#12263f')};
}
